// Sentry behind the cookie choice (A7-1, 26 Sep 2026). Pure: the Sentry SDK is
// passed in, so the rules can be tested without starting it.
//
// Before a choice, Sentry captures ERRORS only. That stores nothing on the
// device, so it needs no consent (PECR reg 6). Session Replay (which keeps the
// recording in the browser) and performance tracing wait for "Allow analytics",
// the same gate Google Analytics and Clarity use (useCookieConsent.loadAnalytics).
// Replay is added from the bundle with addIntegration, never lazyLoadIntegration,
// which would fetch it from Sentry's CDN.

export const SENTRY_TRACES_RATE = 0.2;

let analyticsAllowed = false;

/** 0 until analytics is allowed, then SENTRY_TRACES_RATE. */
export function sentryTracesSampler() {
    return analyticsAllowed ? SENTRY_TRACES_RATE : 0;
}

/** The options Sentry starts with on the client, before any cookie choice. */
export function sentryInitOptions(dsn) {
    return {
        dsn,
        // No Replay here: it is added by allowSentryAnalytics.
        integrations: [],
        // A sampler rather than a rate, so tracing can start on consent without a restart.
        tracesSampler: () => sentryTracesSampler(),
        tracePropagationTargets: ["localhost", /^https:\/\/.*\.tapleagues\.com/],
        // Read by the Replay integration once it is added.
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    };
}

/** "Allow analytics": start Replay and tracing. Safe to call more than once. */
export function allowSentryAnalytics(Sentry) {
    analyticsAllowed = true;
    // Sentry only starts in production builds. With no client there is nothing
    // to add Replay to, and a second Replay instance would throw.
    if (!Sentry?.getClient?.()) return;
    try {
        if (!Sentry.getReplay?.()) Sentry.addIntegration(Sentry.replayIntegration());
    } catch {
        // Never let Replay stop Google Analytics or Clarity loading after it.
    }
}

/** Withdrawal ("Essential only"): stop Replay, and tracing samples nothing. */
export function withdrawSentryAnalytics(Sentry) {
    analyticsAllowed = false;
    Sentry?.getReplay?.()?.stop();
}
